import axios from "axios";
import Swal from "sweetalert2";
import closeIcon from "../../images/Svg/close.svg";
import LoadingShapeIcon from "../../images/Svg/loadingShape.gif";
import { analytics, getTokenData } from "../../utils/firebase";
import RightArrow from "../../images/Svg/LeftArrow.svg";
import { useNavigate, useParams } from "react-router-dom";
import DiamondIcon from "../../images/Svg/OrangeDiamond.svg";
import PopularIcon from "../../images/Svg/PopularIcon.svg";
import NewIcon from "../../images/Svg/NewIcon.svg";
import RealIcon from "../../images/Svg/Feature1.svg";
import PastIcon from "../../images/Svg/Past.svg";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { Fade } from "react-reveal";
import StepComponents, {
  checkArray,
  checkingStep1,
} from "../Dashboard/Step.components";
import NothingFound from "../../images/Svg/syncYourContent/nothingFound.png";
import Light from "../../images/Svg/syncYourContent/light.png";
import { Helmet } from "react-helmet";
import Iframe from "../iframe/Iframe.component";
import { useContext } from "react";
import { ConfigContext } from "../../context/config";
import useIdentity from "../../utils/identity";
import { logEvent } from "firebase/analytics";
import { pushGaEvent } from "../../utils/ga_events";

const SyncContent = () => {
  const dispatch = useDispatch();
  const { twitter, deso, wordpress } = useSelector((state) => state.auth);

  const { identityWindow } = useContext(ConfigContext);
  const { handleMessage } = useIdentity();

  useEffect(() => {
    window.addEventListener("message", (event) =>
      handleMessage(event, identityWindow)
    );
  }, [identityWindow]);

  useEffect(() => {
    if (localStorage.getItem("credential")) {
    } else window.location.href = "/home";
    if (id === "wordpress") {
      if (localStorage.getItem("wordpress_info")) {
      } else {
        window.location.href = "/home";
      }
    } else if (id === "twitter") {
      if (localStorage.getItem("twitter_username")) {
      } else {
        window.location.href = "/home";
      }
    }
  }, [twitter, deso, wordpress]);
  const { id } = useParams();
  const pn = window.location.pathname;
  const result = checkArray(checkingStep1, pn);
  if (result) {
  } else {
    window.location.href = "/";
  }

  let text = {};
  if (id === "twitter") {
    text["title"] = "Tweets";
    text["description"] = "tweets";
  } else if (id === "wordpress") {
    text["title"] = "Blogs";
    text["description"] = "blog posts";
  }

  const [noTweetModal, setNoTweetModal] = useState(false);
  let syncData = [
    {
      icon: RealIcon,
      title: "Real-Time Sync",
      text: "Popular",
      icon2: PopularIcon,
      link: `/${id}/real_time_sync`,
      description: `Your future ${text?.description} will be synced automatically`,
      buttonText: "Subscribe",

      onPress: () => handleRealTimeSync(),
      disable: false,
    },
    {
      icon: PastIcon,
      title: `Sync Past ${id == "twitter" ? "Tweets" : "Blogs"}`,
      text: "New",
      link: `/${id}/past_all_contents`,
      disable: id === "wordpress" ? true : false,
      icon2: NewIcon,
      description: `Your past ${text?.description} will be synced according to your preference`,
      buttonText: id === "twitter" ? "Sync Now" : "Coming Soon",
      onPress: () => handlePastTweets(),
    },
  ];

  const handleRealTimeSync = () => {
    pushGaEvent(id.toUpperCase() + "_REAL_TIME_SYNC_BUTTON_CLICKED");
    window.location.href = `/${id}/real_time_sync`;
  };

  let bodyData;

  if (id === "twitter") {
    bodyData = {
      count: 5,
      user_id: twitter?.user?.providerData[0]?.uid,
    };
  }
  const handlePastTweets = async () => {
    pushGaEvent(id.toUpperCase() + "_PAST_TWEETS_BUTTON_CLICKED");
    axios
      .post(
        "https://web3setu.co.in/tweets/get-recent-tweets-from-username-temp",
        bodyData
      )
      .then((res) => {
        window.location.href = `/${id}/past_all_contents`;
      })
      .catch((err) => {
        let error = { err };
        let status = error.err?.response?.status;
        if (status === 404) {
          pushGaEvent("NO_TWEETS_FOUND");
          setNoTweetModal(true);
        }
      });
  };

  return (
    <section className="container mx-auto py-4 px-4 sm:px-4 md:px-12 mb-[250px]">
      <Iframe />
      <StepComponents />
      <Fade cascade duration={1000}>
        <Helmet>
          <title>Setu - Sync Your Content</title>
          <meta
            name="description"
            content="Log into DeSo and move your content to Web 3.0 with Setu for free. Publish your content securely, earn more, own your content, and expand your brand."
          />
        </Helmet>
        <div className="md:px-4">
          <h1 className={`Secondheading font-bold text-black text-center `}>
            Sync {id === "twitter" ? "Twitter" : "Wordpress"} content for{" "}
            <span className="text-[#E5AC3E]">FREE</span>
          </h1>
          <p className="mt-4 text-[14px] md:text-[16px] md:mx-auto md:w-[417px] text-center">
            Your content will be posted to your Decentralised Social Media
            account. Pick your preference to sync
          </p>
          <div className="flex flex-wrap justify-center items-center mt-[32px]">
            {syncData.map((item) => (
              <div
                key={item?.title}
                className={`${
                  id === "wordpress" ? "h-[339px]" : "h-[339px]"
                } wordpress_card px-[16px] md:px-[32px]  hover:scale-105 ease-in duration-300 shadow-login-card mb-[24px] flex items-center justify-center flex-col`}
              >
                <div>
                  <div className="text-black mb-[8px] flex justify-between items-center">
                    <img src={item.icon} className="w-[56px] h-[56px]" alt="" />
                    <div
                      className={`${
                        item.title == "Real-Time Sync" ? "w-[96px]" : "w-[74px]"
                      } border-[#5463FF] border  h-[29px] rounded-[4px] flex items-center justify-center`}
                    >
                      <img className="pr-[8px]" src={item?.icon2} alt="" />
                      <p className="text-blue text-[14px]">{item.text}</p>
                    </div>
                  </div>
                  <h1 className="text-[24px] mb-[16px] text-black font-bold">
                    {item.title}
                  </h1>
                  <p className="text-[16px]">{item?.description}</p>
                  <div className={`${item?.disable ? "" : "button_hover"}`}>
                    <button
                      disabled={item.disable}
                      onClick={item?.onPress}
                      className={`${
                        item?.disable
                          ? "cursor-auto bg-white text-black hover:bg-white"
                          : "bg-[#5463FF] text-white "
                      } navbar-button justify-center w-[300px] p-5 h-[56px] mx-auto mt-6`}
                    >
                      {item.buttonText}
                    </button>
                  </div>
                  {item?.gift && (
                    <p className="flex justify-between mt-[32px] text-[#F9B636]">
                      <img src={DiamondIcon} alt="" />
                      <span className="pl-[8px]">{item?.gift}</span>
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Fade>
      {noTweetModal && (
        <div className="another_style">
          <div className="invite_section_1 w-[482px] py-[40px]">
            <div className="md:max-w-[337px] w-[100%] mx-auto text-center">
              <img
                className="w-[87px] h-[87px] mx-auto mb-[20px]"
                src={NothingFound}
                alt=""
              />
              <h1 className="text-black thirdHeading text-center">
                We couldn’t find any tweets{" "}
              </h1>
              <p className="text-[#000000] text-center mt-[16px]">
                Ensure that the content is posted on your account. Or try making
                your account public.
              </p>
            </div>
            <div className="border border-[#5463FF] rounded-[8px] flex mt-[24px] max-w-[386px] mx-auto h-[80px]  py-[16px] w-[95%] bg-[#F6F7FF]">
              <img className="w-[24px] h-[24px] ml-[12px]" src={Light} alt="" />
              <p className="text-[#000000] mx-[12px] text-[14px] md:text-[16px]">
                Try subscribing to Real-Time Sync and your future tweets will
                get synced automatically
              </p>
            </div>
            <button
              onClick={() => setNoTweetModal(false)}
              className="hero_button w-[135px] h-[48px] rounded-[8px] justify-center mt-[32px] mx-auto"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default SyncContent;
